<template>
  <div style="width: unset;">
    <button v-if="btnText"
      class="btn sm:inline-flex py-3 tx-18 w-full"
      style="background: rgb(219, 254, 84); color: #000; width: 100%"
      @click="validateUser($event)"
    >
      <strong>{{ btnText }}</strong>
    </button>
    <div v-else>
      <button
        class="btn sm:inline-flex py-3 tx-18"
        style="background: rgb(219, 254, 84); color: #000; width: 100%"
        @click="validateUser($event)"
      >
        <strong>Agendar&nbsp;Cita</strong
        >
      </button>
    </div>
    <div v-if="show" class="overlay active overlay--auth backdrop-blur pt-10">
      <div class="wrapper-lightbox" style="max-width: 560px">
        <div class="close-modal" @click="closeModal">
          <span class="tx-dark-ad">
            <i class="fas fa-times"></i>
          </span>
        </div>
        <div class="lightbox">
          <div class="p-4 md:py-3 md:px-3">
            <p v-if="!btnText" class="tx-20 weight-500 opacity-90">
              Comunícate con el vendedor
            </p>
            <p class="tx-18 opacity-90 m-0 text-center weight-600">
              {{ product.brand.title }} {{ product.model.title }} {{ product.year }}
            </p>
          </div>
          <form id="schedule_appointment_form" @submit.prevent="haddlerSubmit()">
            <div class="container">
              <div class="form-group col-16">
                <!-- <label class="form-label form-label--big" for="">Nombre</label> -->
                <input
                  v-model="name"
                  class="form-input"
                  type="text"
                  placeholder="Nombre"
                />
                <small v-if="errorsBag.name" style="color: red">{{errorsBag.name[0]}}</small>
              </div>
              <div class="form-group col-16">
                <!-- <label class="form-label form-label--big" for="">Celular</label> -->
                <the-mask
                  v-model="phone"
                  class="form-input"
                  type="tel"
                  placeholder="Celular"
                  :masked="false"
                  mask="##-##-##-##-##"
                ></the-mask>
                <small v-if="errorsBag.phone" style="color: red">{{errorsBag.phone[0]}}</small>
              </div>
              <div class="form-group col-16">
                <!-- <label class="form-label form-label--big" for="">Email</label> -->
                <input
                  v-model="email"
                  class="form-input"
                  type="email"
                  placeholder="Email"
                />
                <small v-if="errorsBag.email" style="color: red">{{errorsBag.email[0]}}</small>
              </div>
              <div class="form-group col-16">
                <select id="down_payment" v-model="down_payment" class="form-input">
                  <option value="" disabled selected style="color: lightgray">Seleccionar enganche</option>
                  <option value="Compra de contado">Compra de contado</option>
                  <option value="$100,000 a $150,000">$100,000 a $150,000</option>
                  <option value="$150,000 a $250,000">$150,000 a $250,000</option>
                  <option value="$250,000 a $350,000">$250,000 a $350,000</option>
                  <option value="Más de $350,000">Más de $350,000</option>
                </select>
                <small v-if="errorsBag.down_payment" style="color: red">{{errorsBag.down_payment[0]}}</small>
              </div>
              <div class="form-group col-16">
                <select id="month" v-model="month" class="form-input" @change="generateDaySelectOptions()">
                  <option value="" disabled selected style="color: lightgray">Seleccionar el mes</option>
                  <option v-for="(month, index) in monthSelectOptions" :value="month" :key="index">{{ month }}</option>
                </select>
                <small v-if="errorsBag.month" style="color: red">{{errorsBag.month[0]}}</small>
              </div>
              <div class="form-group col-16">
                <select id="day" v-model="day" class="form-input" :disabled="!month">
                  <option value="" disabled selected style="color: lightgray">Seleccionar el día</option>
                  <option v-for="(day, index) in daySelectOptions" :value="day" :key="index">{{ day }}</option>
                </select>
                <small v-if="errorsBag.day" style="color: red">{{errorsBag.day[0]}}</small>
              </div>
              <div class="form-group col-16">
                <select id="hour" v-model="hour" class="form-input" :disabled="!day">
                  <option value="" disabled selected style="color: lightgray">Seleccionar la hora</option>
                  <option v-for="(hour, index) in hourSelectOptions" :value="hour" :key="index">{{ hour }}</option>
                </select>
                <small v-if="errorsBag.hour" style="color: red">{{errorsBag.hour[0]}}</small>
              </div>
              <div class="form-group col-16">
                <input type="checkbox" name="is_a_trade_in" id="is_a_trade_in" v-model="isATradeIn">
                <label for="is_a_trade_in">Quiero dejar auto a cuenta</label>
              </div>
              <div v-if="isATradeIn">
                <div class="form-group col-16">
                  <input type="text" name="tradein_year" id="tradein_year" class="form-input" placeholder="Año" v-model="tradeinYear">
                  <small v-if="errorsBag.tradein_year" style="color: red">{{errorsBag.tradein_year[0]}}</small>
                </div>
                <div class="form-group col-16">
                  <input type="text" name="tradein_brand" id="tradein_brand" class="form-input" placeholder="Marca" v-model="tradeinBrand">
                  <small v-if="errorsBag.tradein_brand" style="color: red">{{errorsBag.tradein_brand[0]}}</small>
                </div>
                <div class="form-group col-16">
                  <input type="text" name="tradein_model" id="tradein_model" class="form-input" placeholder="Modelo" v-model="tradeinModel">
                  <small v-if="errorsBag.tradein_model" style="color: red">{{errorsBag.tradein_model[0]}}</small>
                </div>
                <div class="form-group col-16">
                  <the-mask
                    v-model="tradeinKilometers"
                    class="form-input"
                    type="text"
                    placeholder="Kilometraje"
                    :masked="false"
                    mask="######"
                  ></the-mask>
                  <small v-if="errorsBag.tradein_kilometers" style="color: red">{{errorsBag.tradein_kilometers[0]}}</small>
                </div>
              </div>
              <input v-if="btnText"
                :disabled="isLoading"
                class="btn weight-700 tx-16 flex mx-a w-full "
                :class="{'opacity-50': isLoading}"
                style="background-color: #000; color: #DBFE54;"
                type="submit"
                :value="btnText"
              />
              <input v-else
                class="btn--whatsapp btn weight-700 tx-16 flex mx-a"
                type="submit"
                value="Enviar whatsapp"
              />
              <br />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VMoney } from 'v-money'

export default {
  props: ["cellphone", "product", "user_id", "message", 'btn-text', "user_name", "user_phone"],
  data() {
    return {
      show: false,
      formData: null,
      err: {},
      name: '',
      phone: '',
      email: '',
      down_payment: '',
      month: '',
      day: '',
      hour: '',
      comments: '',
      errorsBag: {},
      isLoading: false,
      displayText: 'transparent',
      date: new Date(),
      monthSelectOptions: [],
      monthNames: [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ],
      daySelectOptions: [],
      dayNames: [
        'Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'
      ],
      hourSelectOptions: ['9:00', '9:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30',
      '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00'
      ],
      isATradeIn: false,
      tradeinYear: '',
      tradeinBrand: '',
      tradeinModel: '',
      tradeinKilometers: ''
    }
  },
  mounted() {
        this.showDescriptionAssesor();
        this.generateMonthSelectOptions();
    },
  directives: {money: VMoney},
  methods: {
    generateDaySelectOptions() {
      this.daySelectOptions = []
      const selectedMonthIdx = this.monthNames.indexOf(this.month)
      const currentDayOfTheMonth = this.date.getDate()
      const currentYear = (new Date()).getFullYear()
      const lastDayOfSelectedMonth = (new Date(currentYear, selectedMonthIdx + 1, 0)).getDate()

      const maxDate = new Date()
      maxDate.setDate(maxDate.getDate() + 17)
      maxDate.setHours(0,0,0,0)

      const startDay = (new Date()).getMonth() == selectedMonthIdx ? (currentDayOfTheMonth + 1) : 1

      for(let i = startDay; i <= lastDayOfSelectedMonth; i++) {
        const countingDate = new Date(currentYear, selectedMonthIdx, i)
        countingDate.setHours(0,0,0,0)
        if(Math.abs(countingDate.getTime()) > Math.abs(maxDate.getTime())) break;
        if(new Date(currentYear, selectedMonthIdx, i).getDay() == 0) continue; // Sundays are not working days
        this.daySelectOptions.push(i)
      }

      if(this.daySelectOptions.indexOf(this.day) == -1) this.day = ''
    },
    generateMonthSelectOptions() {
      const currentMonthIdx = this.date.getMonth()

      const oneMonthAheadIdx = (currentMonthIdx + 1) <= 11 ? currentMonthIdx + 1 : 0;
      const TwoMonthAheadIdx = (currentMonthIdx + 2) <= 11 ? currentMonthIdx + 2 : 0;

      if(this.date.getDate() < 32)
        this.monthSelectOptions = [this.monthNames[currentMonthIdx], this.monthNames[oneMonthAheadIdx]]
      else
        this.monthSelectOptions = [this.monthNames[oneMonthAheadIdx], this.monthNames[TwoMonthAheadIdx]]
    },
    validateUser(event) {
      if (this.user_id > 0) {
            this.name = this.user_name
            this.phone = this.user_phone
        }
    this.show = true;
    event.preventDefault()
    this.registerClick(event)
    },
    async registerClick(event) {
      await axios
      .post("/client/stats/register-click/", {
        mkt_vehicle_id: this.product.id,
        button: 'appointment'
      })
      .then((response) => {
      })
      .catch((error) => {
        console.error(error);
      })

    },
    showForm(event) {
      event.preventDefault();
      this.show = true;
    },

    async haddlerSubmit() {
      let vm = this;
      vm.isLoading = true;
      vm.errorsBag = {}
      if (this.phone.length < 10) {
        vm.isLoading = false;
        return vm.$swal({
          icon: "error",
          text: 'El número debe ser de 10 dígitos'
        });
      }

      vm.formData = new FormData();
      vm.formData.append("name", vm.name);
      vm.formData.append("phone", vm.phone);
      vm.formData.append("user_id", vm.user_id);
      vm.formData.append("message", vm.message);

      vm.formData.append("email", vm.email)
      vm.formData.append("down_payment", vm.down_payment)
      vm.formData.append("month", vm.month)
      vm.formData.append("day", vm.day)
      vm.formData.append("hour", vm.hour)

      vm.formData.append("interested_prospect", this.btnText?.length > 0 ? 1 : 0)
      vm.formData.append("state_id", this.$cookies.get('stateUser') || 0)

      vm.formData.append('is_a_trade_in', vm.isATradeIn ? 1 : 0)
      vm.formData.append('tradein_year', vm.tradeinYear)
      vm.formData.append('tradein_brand', vm.tradeinBrand)
      vm.formData.append('tradein_model', vm.tradeinModel)
      vm.formData.append('tradein_kilometers', vm.tradeinKilometers)

      if (!vm.btnText)
        this.openWhatsapp(`https://wa.me/${this.cellphone}?text=${this.message}`)

      let message = "?text=" + vm.message;
      let data = await axios
        .post("/client/prospect-appointment/" + vm.product.id, vm.formData)
        .then((response) => {
          vm.closeModal()
          if(vm.btnText)
            vm.$swal({
                icon: "success",
                title: "¡Tu solicitud ha sido enviada!",
                text: "En breve un agente de esta agencia se pondrá en contacto contigo.",
                closeOnConfirm: true,
                cancelButton: false,
                confirmButtonText: 'Aceptar'
            })
            vm.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          vm.isLoading = false;
          if(error.response.status = 422) vm.errorsBag = error.response.data.errors
        })
    },
    resetForm(){
      this.errorsBag = {}
      this.name = ''
      this.phone = ''
      this.email = ''
      this.down_payment = ''
      this.month = ''
      this.day = ''
      this.hour = ''
      this.isATradeIn = false
      this.tradeinYear = ''
      this.tradeinBrand = ''
      this.tradeinModel = ''
      this.tradeinKilometers = ''
      document.getElementById('schedule_appointment_form').querySelector('select > option:first-child').selected = true
    },
    closeModal(buttonClose = false) {
        if (buttonClose) {
            return this.$swal({
                        title: "¡No te pierdas tu próximo auto!",
                        text: "Deja tus datos y un especialista se pondrá en contacto contigo para mostrarte opciones personalizadas",
                        closeOnConfirm: true,
                        cancelButton: true,
                        confirmButtonText: "Volver",
                        cancelButtonText: "Salir",
                        cancelButtonColor: "#000",
                        showCancelButton: true,
                    }).then((result) => {
                        if (!result.isConfirmed) {
                            this.resetForm();
                            this.show = false;
                        }
                    });
            }
      this.resetForm()
      this.show = false
    },
    openWhatsapp (url) {
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
    },
    showDescriptionAssesor(){
      setTimeout(() => {
        this.displayText = 'lightslategray';
      }, 5000);
    }
  }
};
</script>
<style>
.swal2-styled.swal2-cancel {
    color: #dcfe54 !important;
    font-weight: bold !important;
}
</style>
